import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled, { withTheme } from 'styled-components';

const IconWrapper = styled.span`
  margin: ${({ m }) => m ? m : '0'};
  margin-top: ${({ mt, my }) => mt ? mt : my ? my : '0'};
  margin-bottom: ${({ mb, my }) => mb ? mb : my ? my : '0'};
  margin-left: ${({ ml, mx }) => ml ? ml : mx ? mx : '0'};
  margin-right: ${({ mr, mx }) => mr ? mr : mx ? mx : '0'};
  cursor: ${({ showPointer }) => (showPointer ? 'pointer' : 'default')};
  ${({ width }) => (width ? `width: ${width}` : '')};
  ${({ height }) => (height ? `height: ${height}` : '')};
`

const Icon = ({ name, color, theme, onClick, showPointer, ...rest }) => (
  <IconWrapper {...rest} showPointer={showPointer}>
    <FontAwesomeIcon
      icon={name || 'times'}
      color={color || theme.white}
      onClick={onClick}
      {...rest}
    />
  </IconWrapper>
);

const wrappedComp = withTheme(Icon);
export {
  wrappedComp as default,
  Icon
};
